// extracted by mini-css-extract-plugin
module.exports = {"mainSidebar":"MainSidebar_mainSidebar__2cC2W","wrappedSidebar":"MainSidebar_wrappedSidebar__1qGXw"};